import { ChangeEvent } from "react";
import MessageError from "./MessageError";
import { messageError } from "./TextInput";

type Props = {
  name: string;
  label: string;
  value: string;
  disabled: boolean;
  placeholder?: string;
  labelClass?: string;
  className?: string;
  error: string | null;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const TimePickerInput = ({
  name,
  label,
  labelClass = '',
  className = '',
  value,
  disabled,
  error,
  placeholder = "Pilih jam",
  onChange
}: Props) => {
  return (
    <div className={`input-field ${className}`}>
      {label ? <label className={`text-sm font-semibold ml-1 mb-1 ${labelClass}`}>{label}</label> : null}
      <input 
        type="time" 
        name={name}
        placeholder={placeholder}
        value={value} 
        disabled={disabled}
        className={`text-black ${error ? "border-red-500" : "border-gray-300"}`}
        style={{
					borderWidth: error ? "1px" : "1px",
					padding: "18px",
					borderRadius: "10px",
					height: 50,
				}}
        onChange={onChange}
      />

      {error ? <MessageError error={messageError(error)} /> : null}
    </div>
  )
}

export default TimePickerInput